import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconArrow1Right = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 13.938 23.91'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M1.017,23.910 C0.748,23.910 0.480,23.802 0.284,23.588 C-0.086,23.183 -0.059,22.552 0.345,22.181 L11.465,11.961 L0.345,1.742 C-0.059,1.370 -0.086,0.740 0.284,0.335 C0.655,-0.070 1.284,-0.098 1.688,0.274 L13.606,11.227 C13.811,11.416 13.928,11.683 13.928,11.961 C13.928,12.240 13.811,12.507 13.606,12.695 L1.688,23.649 C1.497,23.824 1.257,23.910 1.017,23.910 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconArrow1Right.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
